import { FormType } from '../../../../form-types';
import { TrtEnhancedFollowupQuestionFieldAnswers } from './questions';

const trtEnhancedFollowup: FormType<TrtEnhancedFollowupQuestionFieldAnswers> = {
  name: 'TRT Follow-up',
  questions: [
    {
      key: 'trtEnhancedFollowup_sexAssignedAtBirth',
      next: {
        condition: { 'trtEnhancedFollowup_sexAssignedAtBirth.male': true },
        key: 'generic_heightWeight2025',
        els: 'trtEnhancedFollowup_ineligible'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'trtEnhancedFollowup_healthChanges',
      next: {
        condition: { 'trtEnhancedFollowup_healthChanges.yes': true },
        key: 'trtEnhancedFollowup_healthChangesDetails',
        els: 'trtEnhancedFollowup_urgentSymptoms'
      }
    },
    'trtEnhancedFollowup_healthChangesDetails',
    {
      key: 'trtEnhancedFollowup_urgentSymptoms',
      next: {
        condition: { 'trtEnhancedFollowup_urgentSymptoms.yes': true },
        key: 'trtEnhancedFollowup_emergencyCare',
        els: 'trtEnhancedFollowup_medicationDoing'
      }
    },
    {
      key: 'trtEnhancedFollowup_medicationDoing',
      next: {
        condition: { 'trtEnhancedFollowup_medicationDoing.not_well': true },
        key: 'trtEnhancedFollowup_medicationExperience',
        els: 'trtEnhancedFollowup_sideEffects'
      }
    },
    'trtEnhancedFollowup_medicationExperience',
    {
      key: 'trtEnhancedFollowup_sideEffects',
      next: {
        condition: { 'trtEnhancedFollowup_sideEffects.yes': true },
        key: 'trtEnhancedFollowup_sideEffectsDetails',
        els: 'trtEnhancedFollowup_testicularSizeDecrease'
      }
    },
    'trtEnhancedFollowup_sideEffectsDetails',
    {
      key: 'trtEnhancedFollowup_testicularSizeDecrease',
      next: {
        condition: { 'trtEnhancedFollowup_testicularSizeDecrease.yes': true },
        key: 'trtEnhancedFollowup_hcgInterest',
        els: 'trtEnhancedFollowup_lastDoseDate'
      }
    },
    'trtEnhancedFollowup_hcgInterest',
    'trtEnhancedFollowup_lastDoseDate',
    {
      key: 'trtEnhancedFollowup_doseAdjusted',
      next: {
        condition: { 'trtEnhancedFollowup_doseAdjusted.yes_adjusted': true },
        key: 'trtEnhancedFollowup_doseAdjustedDetails',
        els: 'trtEnhancedFollowup_qadamLibido'
      }
    },
    'trtEnhancedFollowup_doseAdjustedDetails',
    'trtEnhancedFollowup_qadamLibido',
    'trtEnhancedFollowup_qadamEnergy',
    'trtEnhancedFollowup_qadamStrengthEndurance',
    'trtEnhancedFollowup_qadamEnjoymentOfLife',
    'trtEnhancedFollowup_qadamMood',
    'trtEnhancedFollowup_qadamErections',
    'trtEnhancedFollowup_qadamWorkPerformance',
    'trtEnhancedFollowup_qadamSleepAfterDinner',
    'trtEnhancedFollowup_qadamSportsPerformance',
    'trtEnhancedFollowup_qadamHeightLost',
    'trtEnhancedFollowup_treatmentPreference',
    {
      key: 'trtEnhancedFollowup_hasRecentLabResults',
      next: {
        condition: { 'trtEnhancedFollowup_hasRecentLabResults.yes': true },
        key: 'trtEnhancedFollowup_recentLabsUpload',
        els: 'trtEnhancedFollowup_additionalQuestions'
      }
    },
    'trtEnhancedFollowup_recentLabsUpload',
    'trtEnhancedFollowup_additionalQuestions',
    {
      key: 'trtEnhancedFollowup_consent',
      next: {
        condition: { 'trtEnhancedFollowup_consent.non_consent': true },
        key: 'trtEnhancedFollowup_ineligible',
        els: 'trtEnhancedFollowup_complete'
      }
    },
    'trtEnhancedFollowup_complete',
    'trtEnhancedFollowup_emergencyCare',
    'trtEnhancedFollowup_ineligible'
  ]
};

export default trtEnhancedFollowup;
